export const GET_USAGE_RECORD_REPORTS_REQUEST = "GET_USAGE_RECORD_REPORTS_REQUEST";
export const GET_USAGE_RECORD_REPORTS_SUCCESS = "GET_USAGE_RECORD_REPORTS_SUCCESS";
export const GET_USAGE_RECORD_REPORTS_ERROR = "GET_USAGE_RECORD_REPORTS_ERROR";

export const getUsageRecordsV2 = {
  GET_USAGE_RECORDS_V2_REQUEST: "GET_USAGE_RECORDS_V2_REQUEST",
  GET_USAGE_RECORDS_V2_SUCCESS: "GET_USAGE_RECORDS_V2_SUCCESS",
  GET_USAGE_RECORDS_V2_ERROR: "GET_USAGE_RECORDS_V2_ERROR",
};
